import { useDroppable } from '@dnd-kit/react';
import { cn } from '@repo/lib/cn';

import { useCalendarDnd } from '@/components/features/calendar';

interface DroppableCellProps {
  id: string;
  date: Date;
  time?: number;
  disabled?: boolean;
  children?: React.ReactNode;
  className?: string;
  onClick?: () => void;
}

export function DroppableCell(dropableCellProps: DroppableCellProps) {
  const { id, date, time, disabled = false, children, className, onClick } = dropableCellProps;
  const { activeEvent } = useCalendarDnd();

  const { ref: setNodeRef, isDropTarget } = useDroppable({
    id,
    disabled,
    data: {
      date,
      time,
    },
  });

  // Format time for display in tooltip
  const formattedTime =
    time !== undefined
      ? `${Math.floor(time)}:${Math.round((time - Math.floor(time)) * 60)
          .toString()
          .padStart(2, '0')}`
      : null;

  return (
    <div
      ref={setNodeRef}
      onDoubleClick={disabled ? undefined : onClick}
      className={cn('data-dragging:bg-accent flex h-full flex-col overflow-hidden px-0.5 py-1 sm:px-1', className)}
      title={formattedTime ? `${formattedTime}` : undefined}
      data-dragging={(isDropTarget && activeEvent) || undefined}
    >
      {children}
    </div>
  );
}
